// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-20adda21] .el-range-separator {\n  width: 12%;\n}\n[data-v-20adda21] .el-col-15:nth-of-type(1) {\n  width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
